import { render } from "./StreamsWidgetLiveStreamTab.vue?vue&type=template&id=beff5aa6"
import script from "./StreamsWidgetLiveStreamTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidgetLiveStreamTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamsWidgetLiveStreamTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beff5aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beff5aa6', __exports__)) {
    api.reload('beff5aa6', __exports__)
  }
  
  module.hot.accept("./StreamsWidgetLiveStreamTab.vue?vue&type=template&id=beff5aa6", () => {
    api.rerender('beff5aa6', render)
  })

}


export default __exports__